import { render, staticRenderFns } from "./PPanelButton.vue?vue&type=template&id=59d36ebd"
import script from "./PPanelButton.vue?vue&type=script&lang=js"
export * from "./PPanelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports